<template>
  <nav>
    <div id="top-menu" class="top-bar">
      <div class="top-bar-right">
        <ul id="inside-nav" class="dropdown menu" data-dropdown-menu>
          <li class="hide-for-small-only menu-text">
            <router-link tag="a" :to="{name: 'Home'}">{{ $t('hero.brand') }}</router-link>
          </li>
          <li id="hmenu" @click="isMobileOpen = !isMobileOpen" class="menu-toggle menu-text">
            <a uid="" href="#" class="menu-text">
              <button class="menu-icon dark" type="button"></button>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div id="mobile-nav" v-show="isMobileOpen">
      <ul>
        <li @click="scrollTo('hero')" class="menu-text"><a uid="hero" href="#">{{ $t('hero.brand') }}</a></li>
        <hr>
        <li @click="scrollTo('services')" class="menu-text"><a uid="services" href="#">{{ $t('service.title') }}</a></li>
        <hr>
        <li @click="scrollTo('whyus')" class="menu-text"><a uid="whyus" href="#">{{ $t('whyus.title') }}</a></li>
        <hr>
        <li @click="scrollTo('gallery')" class="menu-text"><a uid="gallery" href="#">{{ $t('gallery.title') }}</a></li>
        <hr>
        <li @click="scrollTo('contact')" class="menu-text"><a uid="contact" href="#">{{ $t('contact.title') }}</a></li>
        <hr>
        <li @click="scrollTo('today')" class="menu-text"><a uid="today" href="#">{{ $t('today.title') }}</a></li>
        <hr>
        <li @click="isMobileOpen = false" class="menu-text callout">
          <button class="close-button" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navigation',
  data () {
    return {
      active: '',
      isMobileOpen: false
    }
  },
  methods: {
    goHomeTop () {
      this.isMobileOpen = !this.isMobileOpen
      this.scrollTo('hero')
    },
    scrollTo (tag) {
      this.isMobileOpen = false
      this.active = tag
      if (this.$route.name !== 'Home') {
        this.$router.replace({name: 'Home', params: {to: tag}})
      } else {
        this.$SmoothScroll(this.getElementPosition(document.getElementById(tag)))
      }
    },
    getElementPosition (element) {
      let yPosition = 0
      while(element) {
        yPosition += (element.offsetTop - element.scrollTop + element.clientTop)
        element = element.offsetParent
      }
      return yPosition
    }
  }
}
</script>

<style lang="scss" scoped>
.top-bar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 66px;
  z-index: 100;
  color: #292929cb;
  background-color: rgba(0, 0, 0, 0);
  &-right {
    flex: 0 1 auto !important;
    margin-left: auto !important;
  }
  ul {
    background-color: rgba(0, 0, 0, 0);
    span {
      display: inline-block;
    }
  }
  li {
    cursor: pointer;
    a {
      color: #292929cb;
      &.active {
        color: rgb(255,200,25);
      }
    }
  }
}
#mobile-nav {
  ul {
    margin: 0;
  }
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  .menu-text {
    padding: 1em 2em;
    margin: 1em;
    list-style: none;
  }
  .callout {
    display: flex;
    border: none;
    justify-content: center;
    align-items: center;
    .close-button {
      right: 0;
      top: 0;
      position: relative;
      color: rgb(206, 26, 26);
    }
  }
}

#hmenu {
  padding-left: 0;
  padding-right: 0;
}
</style>

